<template>
   <div>
    <div class="transaction-explorer mt-14 mb-14">
      <div class="mb-[10px]">
        <Paragraph class="text-blue-dark font-jost-regular text-[25px]" text="Proxy Multisig Account" />
        <div class="flex gap-[20px] max-w-max relative w-auto">
          <p class="text-blue-light break-all font-jost-regular w-full text-blue-light text-left" style="font-size: 25px">
            {{ publicAddress }}
            <span class="inline-block cursor-pointer" title="Copy hash">
              <CopyIcon :isActive="checkIfIsEqual(publicAddress)" @click="copy(publicAddress)" title="Copy hash"
                class="h-[33px] ml-2 inline-block cursor-pointer" />
            </span>
          </p>
        </div>
      </div>

      <section class="t-results justify-between text-lg mt-5 mt-[105px] flex">
        <div>
          <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px] mb-[11px]" text="Overview" />

          <div v-if="loaders.accountDetails"
            class="overview__section bg-white rounded-[9px] flex justify-center w-full mt-[30px] w-[676px] h-[250px] items-center">
            <Loader color="#64748B" width="30px" height="30px" />
          </div>
          <section v-else class="overview__section w-[676px] flex flex-wrap gap-[100px]">
            <div v-if="!loaders.accountDetails && account && Object.keys(account).length"
              class="t-results-body bg-white w-full">
              <div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    COIN Balance
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.balance }} GEEQ
                    </span>
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Chain Number
                  </div>
                  <div class="col px-2.5">
                    #{{ account.chainNumber }}
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Total Transactions
                  </div>
                  <div class="col px-2.5">
                    <div class="flex gap-[5px] items-center">
                      <img src="/images/icons/sent-txs.png" />
                      <span class="font-jost-bold text-blue-dark text-[18px] leading-[26px]">
                        {{ account.sentTransactions }}
                      </span>

                      <img src="/images/icons/received-txs.png" />
                      <span class="font-jost-bold text-blue-dark text-[18px] leading-[26px]">
                        {{ account.receiveTransactions }}
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Multisig Threshold
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.threshold || 'N/A' }}
                    </span>
                  </div>
                </div>

                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Signers Count
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.signersCount || 'N/A' }}
                    </span>
                  </div>
                </div>

                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Created At
                  </div>

                  <div class="font-jost-regular px-2.5 text-blue-dark">
                    <router-link v-if="account && account.blockNumber" class="block flex relative cursor-pointer text-blue-light"
                      :to="{ name: 'block', params: { chainNumber: account.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: account.blockNumber } }">
                      Block #{{ account.blockNumber }}
                    </router-link>
                    {{ getTxCreationDateUtc() }} UTC
                  </div>
                </div>
              </div>
            </div>
            <Paragraph text="We couldn't find any results.." class="text-blue-dark text-lg mt-5 float-left" v-else />
          </section>
        </div>
        <OwnedNftsPanel :account-address="publicAddress" :chain-number="$route.params.chainNumber" />
      </section>
      <div v-show="loaders.transactions"
        class="tbl-container mt-20 rounded-[9px] mb-[50px] flex justify-center w-full mt-[30px] h-[380px] items-center">
        <Loader color="#64748B" width="30px" height="30px" />
      </div>
    </div>
  </div>
</template>

<script>
import "vue-json-pretty/lib/styles.css";

import api from '@/helpers/api';
import string from '@/helpers/string';
import CopyIcon from '@/components/svg/CopyIcon';
import Loader from '@/components/common/Loader.vue';

import Paragraph from "@/components/web/ParagraphComponent";
import OwnedNftsPanel from '@/components/web/OwnedNftsPanel.vue';

import { maxTableRows } from "@/utils/pagination";
import moment from 'moment';

export default {
  name: "ProxyMultisigAccountComponent",
  components: {
    CopyIcon,
    Loader,
    Paragraph,
    OwnedNftsPanel
  },
  props: {
    walletAddress: {
      required: true
    },
    publicAddress: {
      required: true
    },
  },
  computed: {
    accountTransactions() {
      return this.accountTxsDetails && this.accountTxsDetails.items ? this.accountTxsDetails.items : [];
    },
    activeTab: {
      get() {
        if (!this.$data._activeTab && this.accountTransactions.length) {
          return 'transactions';
        }
        return this.$data._activeTab;
      },
      set(value) {
        this.$data._activeTab = value;
      }
    },
    routeName() {
      return this.$route.name
    },
    areTabsVisible() {
      return this.accountTransactions.length > 0;
    },
  },
  data: () => {
    return {
      loaders: {
        accountDetails: true,
        transactions: true,
      },
      account: null,
      copied: '',
      initialPage: 1,
      pageSize: maxTableRows,
      transactionRefHash: "",
      virtualFlag: false,
      showLine: true,
      lastPath: null,
      collapsedOnClickBrackets: true,
      currentScrollItem: 1,
      transactionData: {},
      accountTxsDetails: {
        meta: {},
        items: []
      },
      pageCount: 0,
    }
  },

  created() {
    this.lastPath = this.$router.options.history.state.back;
    this.searchByAccPublicAddress(this.walletAddress);
    this.getAccountAllTransactons(this.publicAddress, maxTableRows, 0);
  },

  methods: {
    changeActiveTab(tabName) {
      this.activeTab = tabName;
    },
    setCopied(hash) {
      this.copied = hash;
    },
    getShortenedText(str) {
      return string.getShortenHash(str)
    },
    getAccountAllTransactons(address, maxTableRows, page) {
      this.loaders.transactions = true;

      return api.getProxyAccountTransactions(address, maxTableRows, page)
        .then((res) => {
          const data = res ? res.data : {};
          this.pageCount = data.meta ? data.meta.count : 1;
          this.accountTxsDetails = data;

          this.loaders.transactions = false;
        })
        .catch(() => {
          this.loaders.transactions = false;
        })
    },
    getTxCreationDateUtc() {
      const createdAt = this.account.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment.utc(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    getItem(page) {
      const normalizedPage = Number(page) > 0 ? Number(page) : 1;
      const skip = (normalizedPage - 1) * maxTableRows;
      this.getAccountAllTransactons(this.publicAddress, maxTableRows, skip)
    },
    setFoundResult(data) {
      const page = Number(data?.page) > 0 ? Number(data.page) : 1;
      this.getItem(page);
    },
    getInitialPage() {
      let page = this.initialPage;
      if (this.activeTab === 'transactions' && this.accountTransactions.length) {
        page = this.accountTxsDetails.meta ? this.accountTxsDetails.meta.skip / this.pageSize + 1 : this.initialPage;
      }
      return page;
    },
    getTitle() {
      return this.routeName === "transaction" ? "AppCommitHash" : "RefHash"
    },
    goBack() {
      this.$router.push({ name: 'search-result' })
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    searchByAccPublicAddress() {
      this.loaders.accountDetails = true;

      return api.getProxyAccountDetails(this.walletAddress)
        .then((res) => {
          const data = res.data;
          this.account = data.result;

          this.loaders.accountDetails = false;

        })
        .catch(() => {
          this.loaders.accountDetails = false;
        })
    },
  }
}
</script>

<style>
* {
  font-family: 'Jost-regular', sans-serif;
}

.transaction-explorer .vjs-value {
  color: #2699FB !important;
  font-size: 18px;
  line-height: 26px;
  font-family: 'Inter-Regular', monospace !important;
}

.transaction-explorer .vjs-tree {
  font-size: 18px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
}

.transaction-explorer .vjs-key {
  font-family: 'Inter-Regular', monospace !important;
}
</style>

<style scoped>
.col {
  width: 30%;
}

.t-results-body {
  padding: 15px 15px 10px 15px;
  border-radius: 9px 9px 9px 9px;
}

.t-results-body .row:first-child {
  border-top: unset;
}

.is-active {
  background-color: #D66339;
}

@media(max-width:1750px) {
  .t-results {
    gap: 20px;
  }
}

@media(max-width:1500px) {
  .overview__section {
    max-width: 570px;
  }
}

@media (max-width: 767px) {
  .main-container {
    padding: 20px 0px !important;
  }

  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 680px;
  }
}

@media (max-width: 715px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 600px;
  }
}

@media (max-width: 620px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 500px;
  }
}

@media (max-width: 520px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 400px;
  }
}

@media (max-width: 420px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 100%;
  }
}

@media (max-width: 390px) {
  .overview__section {
    width: 320px;
  }
}
</style>
